module.exports = __webpack_public_path__ + "img/IMG_8942.b3bb7bcc.jpg";